var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownloadBold = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0752 18.2263V8.20376C28.0752 7.13807 28.9253 6.25 30.0002 6.25C30.9627 6.25 31.7782 6.99623 31.9074 7.94145L31.9252 8.20376V18.2263L43.875 18.2271C49.825 18.2271 54.7134 23.0995 54.9878 29.176L55 29.7152V42.3135C55 48.4326 50.2816 53.4555 44.4201 53.7375L43.9 53.75H16.1C10.15 53.75 5.28522 48.902 5.01209 42.8031L5 42.2618L5 29.6894C5 23.5703 9.69477 18.523 15.555 18.2396L16.075 18.2271H28.075V34.233L24.075 30.1025C23.325 29.328 22.1 29.328 21.35 30.1025C20.975 30.4897 20.8 31.006 20.8 31.5224C20.8 31.9148 20.912 32.3237 21.1488 32.6698L21.35 32.9164L28.625 40.4547C28.975 40.842 29.475 41.0485 30 41.0485C30.4167 41.0485 30.8333 40.9051 31.1632 40.6332L31.35 40.4547L38.625 32.9164C39.375 32.1419 39.375 30.8769 38.625 30.1025C37.9432 29.3984 36.8688 29.3344 36.1156 29.9104L35.9 30.1025L31.925 34.233V18.2271L28.0752 18.2263Z",
    fill: "#CBCBCB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DownloadBold.4f57049b.svg";
export { ForwardRef as ReactComponent };